import { Component, OnInit } from '@angular/core';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { Router } from '@angular/router';
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';


@Component({
  selector: 'app-email-content',
  templateUrl: './email-content.component.html',
  styleUrls: ['./email-content.component.scss'],
})
export class EmailContentComponent  implements OnInit {
  buttonColorName:any;
  EmailContent:any
  isEditEmail = false
  emailContentSubject:any = `Increment Letter`;
  isInvalidIncrementEmailSubject:any = false;
  emailContentBody: any = `<b>Dear #EmployeeName#,</b><div><b><br></b>We are pleased to inform you that, as a result of an appraisal of your performance, your remuneration has been modified W.E.F April 1, 2022, and the new salary structure is as follows: <br><br>Previous Salary: Rs. 53000/- <br>Increment: Rs. 7000/- <br>New Salary: Rs. 60000/- <br><br>Please contact the HR department for the remainder of the week breakdown and other terms and conditions. We look forward to your valuable contributions to the company and wish you success in your future efforts. As a show of acceptance, please sign the duplicate copy of this letter.<br><br>Yours truly, <br><br>Signature Kevin Durant <br><br>Yours truly<br><br>Signature<br><br>Kevin Durant<br><br>HR Manager</div>`;
  isInvalidsetIncrementEmailContent:any = false;
  loggedInUserCompanyID:any;
  loggedInCompanyFiscalyear: any;
  getIncrementFyYearList:any[] = [];
  fromYear:any;
  toYear:any;
  emailContentFyYearList:any[] = [];
  isDisabledIncrementLetter:any = false;

  emailContentSubjectData:any
  emailContentBodyData:any
  
  // editorConfig = {
  //   editable: true,
  //     spellcheck: true,
  //     height: '400px',
  //     minHeight: '0',
  //     maxHeight: 'auto',
  //     width: 'auto',
  //     minWidth: '0',
  //     translate: 'yes',
  //     enableToolbar: true,
  //     showToolbar: true,
  //     placeholder: 'Enter Email here...',
  //     defaultParagraphSeparator: '',
  // }
editorConfig = {
    enter: 'BR',
    height: 430,
    toolbarSticky: false,
    toolbarAdaptive: false,
    askBeforePasteHTML: true,
    askBeforePasteFromWord: true,
    defaultActionOnPaste: 'insert_as_html',
    language: 'en',
    i18n: {
      en: {
        'Paste as HTML': 'Paste',
        'Your code is similar to HTML. Keep as HTML?':
          'Do you want to keep this content as it is?',
      }
    },
    uploader: { insertImageAsBase64URI: true },
    buttons: [
      'bold', 'italic', 'underline', '|',
      'ul', 'ol', '|',
      'left', 'center', 'right', 'justify', '|',
      'preview', '|',
      'undo', 'redo', '|',
      'fontsize'
    ]
  };
  constructor(public dialog: MatDialog, private router:Router,  private httpService: HttpService,
  private config: Config, private encryptionService: EncryptionService
  ) { }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
  }

  ionViewWillEnter(){
    this.getIncrementFYyear();  
    this.getIncrementSetup();  
  }

  onClickSetup(operation: any) {
    this.router.navigate(['/home/hrportal/increment', { operation: operation }]);
  }
  

  getIncrementFYyear(){
    const request =  {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": null,
      "toYear": null
    }    
    this.httpService.callPostService(this.config.getOverallBudgetGrid, request).subscribe((result:any)=>{             
      this.getIncrementFyYearList = result.data.map((ele: any) => ({
        fromYear: ele.fromYear,
        toYear: ele.toYear,
        year: `${ele.fromYear}-${ele.toYear}`,
      }));
      const currentYear = new Date().getFullYear();
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth(); 
        let yearValue = '';
        if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
          yearValue = `${currentYear}-${currentYear}`;
        } else {
          yearValue = `${currentYear}-${currentYear + 1}`;
          if(this.loggedInCompanyFiscalyear === 'Apr_Mar'){
            if(currentMonth<3){
              yearValue = `${currentYear-1}-${currentYear}`;
            }else{
              yearValue = `${currentYear}-${currentYear + 1}`;
            }
          }
          if(this.loggedInCompanyFiscalyear === 'July_Jun'){
            if(currentMonth<6){
              yearValue = `${currentYear-1}-${currentYear}`;
            }else{
              yearValue = `${currentYear}-${currentYear + 1}`;
            }
          }
          if(this.loggedInCompanyFiscalyear === 'Oct_Sep'){
            if(currentMonth<9){
              yearValue = `${currentYear-1}-${currentYear}`;
            }else{
              yearValue = `${currentYear}-${currentYear + 1}`;
            }
          }
        }
      let selectedYearIndex = this.getIncrementFyYearList.findIndex((ele: any) => ele.year === yearValue);
      if (selectedYearIndex === -1) {
        selectedYearIndex = 0;
      }
      this.fromYear = this.getIncrementFyYearList[selectedYearIndex].fromYear;
      this.toYear = this.getIncrementFyYearList[selectedYearIndex].toYear;
      this.getIncrementSetup();
      this.getMDApprovedData()
    })
  }

  getMDApprovedData() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "toYear": this.toYear
    }
    this.httpService.callPostService(this.config.getIncrementApprovalDataOfCompany, request).subscribe((result: any) => {
      if (result.data?.mdReviewStatus == "Approved") {
        this.isDisabledIncrementLetter = true;
      }
      else if (result.data?.mdReviewStatus == "Rejected") {
        this.isDisabledIncrementLetter = false;
      }
      else {
        this.isDisabledIncrementLetter = false;
      }
    })
  }

  onClickEdit(){ 
 
  setTimeout(() => {
    this.isEditEmail = true;    
    this.emailContentSubject = "Increment Letter";
    this.emailContentBody = `<b>Dear #EmployeeName#,</b><div><b><br></b>We are pleased to inform you...`;

    this.getIncrementSetup(); // Load the data
  }, 200);




  }

  isDiscardChanges(){
    this.isEditEmail = false;
    this.emailContentSubject = "";
    this.emailContentBody = "";
    this.getIncrementSetup()
  }

  onClickSaveBtn(){
    if (!this.emailContentSubject && this.emailContentBody) {
     window.alert("Enter Email Subject")
    }
    
    if (!this.emailContentBody && this.emailContentSubject) {
      window.alert("Enter Email")
    }

    if (!this.emailContentSubject && !this.emailContentBody) {
      window.alert("Enter Email and Email Subject")
    }

    if (this.emailContentSubject && this.emailContentBody) {
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '30%',
        width: window.innerWidth <= 500 ? '90%' : window.innerWidth <= 800 ? '50%' : '30%',
        data: {
          msg: 'Email Template Updated Successfully',
          btn2: 'Done',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false
        },
      });
  
      dialogRef.afterClosed().subscribe((result: any) => {
        if (result) {
          this.isEditEmail = false;
          const request = {
            "companyId": this.loggedInUserCompanyID,
            "emailContentBody": this.emailContentBody,
            "emailContentSubject": this.emailContentSubject,
            "fromYear": this.fromYear,
            "incrementPolicyFileName": null,
            "incrementPolicyUrl": null,
            "toYear": this.toYear
          };  
          this.httpService.callPostService(this.config.setEmailContent, request).subscribe((result) => { 
            this.getIncrementSetup();
          });
        }
      });
    }
  }

  getIncrementSetup(){
    const request =  {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "toYear": this.toYear
    }    
    this.httpService.callPostService(this.config.getIncrementSetupByYear, request).subscribe((result:any)=>{
      if (result && result.data) {
        this.emailContentSubjectData = result.data.emailContentSubject;
        this.emailContentBodyData = result.data.emailContentBody;
         // Patch into editor here
    this.emailContentSubject = this.emailContentSubjectData || "Increment Letter";
    this.emailContentBody = this.emailContentBodyData || `<b>Dear #EmployeeName#,</b><div><b><br></b>We are pleased to inform you that, as a result of an appraisal of your performance, your remuneration has been modified W.E.F April 1, 2022, and the new salary structure is as follows: <br><br>Previous Salary: Rs. 53000/- <br>Increment: Rs. 7000/- <br>New Salary: Rs. 60000/- <br><br>Please contact the HR department for the remainder of the week breakdown and other terms and conditions. We look forward to your valuable contributions to the company and wish you success in your future efforts. As a show of acceptance, please sign the duplicate copy of this letter.<br><br>Yours truly, <br><br>Signature Kevin Durant <br><br>Yours truly<br><br>Signature<br><br>Kevin Durant<br><br>HR Manager</div>`; 
      }
    })
  }

 addToEditor(textToAdd: string) {
  const editor = document.getElementById('htmlDiv');
  if (editor) {
    let htmlToInsert: string;

    // If it's not PromotionContent, make it bold
    if (textToAdd !== '#PromotionContent#') {
      htmlToInsert = `<span><b>${textToAdd}</b></span>`;
    } else {
      htmlToInsert = `<span>${textToAdd}</span>`;
    }

    document.execCommand('insertHTML', false, htmlToInsert);
  }
}

}
